export enum ConsumerLoanLogEventType {
        TrackingSend = 0,
        TrackingFail,
        TrackingSuccess,
        TrackingBlocked
}
